import { unzlibSync } from "fflate";
import SWFByteReader from "./SWFByteReader";
export default class SWFUnpacker {
    static parse(fileList, data, dir) {
        return new Promise((resolve, reject) => {
            let swfData = this.uncompress(data);
            if (swfData == null) {
                console.error("SWF Parse Error, swfData is null.");
                reject(false);
            }
            fileList.push({
                name: 'chart.ffr',
                dir: dir,
                path: dir + 'chart.ffr',
                data: this.chartBuild(swfData.tags)
            });
            fileList.push({
                name: 'audio.mp3',
                dir: dir,
                path: dir + 'audio.mp3',
                data: this.musicBuild(swfData.tags)
            });
            resolve(true);
        });
    }
    static chartBuild(tags) {
        let len = tags.length;
        let elm;
        for (let i = 0; i < len; i++) {
            elm = tags[i];
            if (elm.header.code == 12 /* SWFTags.DOACTION */) {
                if (elm.variables['_root'] !== undefined && elm.variables['_root']['beatBox'] !== undefined) {
                    return elm.variables['_root']['beatBox'];
                }
            }
        }
        return null;
    }
    static musicBuild(tags) {
        let len = tags.length;
        let i = 0;
        let elm;
        let audioSize = 0;
        // Loop All Audio Tags, get Total Byte Size
        for (i = 0; i < len; i++) {
            elm = tags[i];
            if (elm.header.code == 14 /* SWFTags.DEFINESOUND */ || elm.header.code == 19 /* SWFTags.STREAMBLOCK */)
                audioSize += elm.audio_bytes;
        }
        // Loop All Audio Tags, get Total Byte Size
        let writePosition = 0;
        let binary = new Uint8Array(audioSize);
        for (i = 0; i < len; i++) {
            elm = tags[i];
            if (elm.header.code == 14 /* SWFTags.DEFINESOUND */ || elm.header.code == 19 /* SWFTags.STREAMBLOCK */) {
                binary.set(new Uint8Array(elm.data), writePosition);
                writePosition += elm.audio_bytes;
            }
        }
        return binary.buffer;
    }
    /**
     * Concat SWF Header with uncompressed Buffer
     */
    static header(buff, swf) {
        let tmp = new Uint8Array(buff.byteLength + 8);
        tmp.set(new Uint8Array(swf.slice(0, 8)));
        tmp.set(new Uint8Array(buff), 8);
        return tmp.buffer;
    }
    /**
     * Decompress SWF if needed and Read SWF
     */
    static uncompress(swf) {
        let swf_bytes = new Uint8Array(swf);
        let compressed_buff = new Uint8Array(swf.slice(8));
        // uncompress buffer
        switch (swf_bytes[0]) { // MAGIC
            case 0x43: // 'C' = zlib compressed
                return SWFUnpacker.reader(new SWFByteReader(SWFUnpacker.header(unzlibSync(compressed_buff), swf)), swf);
            case 0x46: // 'F' = uncompressed
                return SWFUnpacker.reader(new SWFByteReader(swf), swf);
            case 0x5A: // LZMA compressed
                console.error('Cannot handle LZMA SWF compressions');
                break;
            default:
                console.error('Unknown SWF compressions');
                break;
        }
        return null;
    }
    /**
     * Reads the SWF from uncompressed buffer.
     */
    static reader(reader, source_data) {
        reader.seek(0); // start
        let swf = {
            buffer: reader,
            magic: reader.readStringFixed(3),
            version: reader.readUInt8(),
            fileLength: {
                compressed: source_data.byteLength,
                uncompressed: reader.readUInt32()
            },
            frameSize: reader.readRect(),
            frameRate: reader.readUInt16() / 256,
            frameCount: reader.readUInt16(),
            tags: null
        };
        try {
            swf.tags = SWFUnpacker.tagReader(reader);
        }
        catch (e) {
            console.log(e);
        }
        return swf;
    }
    /**
     * Parses the SWF TAG data structure, keeping only the tags we are interested in.
     * - Audio Tags: Audio Samples
     * - Do Action Tag: Containing the beatBox variable.
     *
     * TODO: Type Better.
     */
    static tagReader(reader) {
        let tags = [];
        let tag;
        let tagHeader;
        let mp3Format = 0;
        let mp3Stream = false;
        /* Reads TagCodeAndLength from Tag's RECORDHEADER */
        while ((tagHeader = reader.readTagCodeAndLength()) !== undefined) {
            tag = {
                header: tagHeader,
                doInclude: false
            };
            switch (tagHeader.code) {
                // Sound Tags - MP3 Extraction
                case 19 /* SWFTags.STREAMBLOCK */:
                    if (!mp3Stream || ((tagHeader.length - 4) == 0))
                        break;
                    reader.readUInt16(); // frame samples
                    reader.readUInt16(); // seek samples
                    tag.data = reader.buffer_raw.slice(reader.pointer, reader.pointer + (tagHeader.length - 4));
                    tag.audio_bytes = (tagHeader.length - 4);
                    tag.doInclude = true;
                    break;
                case 18 /* SWFTags.STREAMHEAD */:
                case 45 /* SWFTags.STREAMHEAD2 */:
                    reader.readUInt8();
                    mp3Format = reader.readUInt8();
                    reader.readUInt16(); // average frame samples
                    reader.readUInt16(); // seek samples
                    if (((mp3Format >>> 4) & 0xf) == 2 /* SWFOtherTags.CODEC_MP3 */)
                        mp3Stream = true;
                    break;
                case 14 /* SWFTags.DEFINESOUND */:
                    if (!mp3Stream) {
                        reader.readUInt16(); // id
                        let format = reader.readUInt8();
                        if (((format >>> 4) & 0xf) == 2 /* SWFOtherTags.CODEC_MP3 */) {
                            reader.readUInt32(); // mp3Samples
                            reader.readUInt16(); // seek samples
                            tag.data = reader.buffer_raw.slice(reader.pointer, reader.pointer + (tagHeader.length - 9));
                            tag.audio_bytes = (tagHeader.length - 9);
                            tag.doInclude = true;
                        }
                    }
                    break;
                // DoAction - Where the Beatbox Lives
                case 12 /* SWFTags.DOACTION */: {
                    //console.log("Found a SWFTags.DOACTION Tag!");
                    let _finishedReading = false;
                    let actionStack = [];
                    let actionVariables = {};
                    let actionRegisters = [null, null, null, null];
                    let constantPool = [];
                    while (!_finishedReading) {
                        let action = reader.readAction();
                        // Read Action Tag
                        switch (action.action) {
                            case 0 /* SWFActionTags.END */: {
                                _finishedReading = true;
                                break;
                            }
                            case 136 /* SWFActionTags.CONSTANTPOOL */: {
                                constantPool = [];
                                let constantCount = reader.readUInt16();
                                for (let i = 0; i < constantCount; i++) {
                                    constantPool.push(reader.readString());
                                }
                                break;
                            }
                            case 150 /* SWFActionTags.PUSH */: {
                                while (reader.pointer < action.position + action.length) {
                                    let pushValue = undefined;
                                    let pushType = reader.readUInt8();
                                    switch (pushType) {
                                        case 0 /* SWFTypeTags.STRING_LITERAL */:
                                            pushValue = reader.readString();
                                            break;
                                        case 1 /* SWFTypeTags.FLOAT_LITERAL */:
                                            pushValue = reader.readFloat();
                                            break;
                                        case 2 /* SWFTypeTags.NULL */:
                                            pushValue = null;
                                            break;
                                        case 3 /* SWFTypeTags.UNDEFINED */:
                                            pushValue = undefined;
                                            break;
                                        case 4 /* SWFTypeTags.REGISTER */:
                                            pushValue = actionRegisters[reader.readUInt8()];
                                            break;
                                        case 5 /* SWFTypeTags.BOOLEAN */:
                                            pushValue = Boolean(reader.readUInt8());
                                            break;
                                        case 6 /* SWFTypeTags.DOUBLE */:
                                            pushValue = reader.readDouble();
                                            break;
                                        case 7 /* SWFTypeTags.INTEGER */:
                                            pushValue = reader.readUInt32();
                                            break;
                                        case 8 /* SWFTypeTags.CONSTANT8 */:
                                            pushValue = constantPool[reader.readUInt8()];
                                            break;
                                        case 9 /* SWFTypeTags.CONSTANT16 */:
                                            pushValue = constantPool[reader.readUInt16()];
                                            break;
                                        default:
                                            console.log("FOUND UNSUPPORTED PUSHDATA TYPE: " + pushType);
                                            break;
                                    }
                                    actionStack.push(pushValue);
                                }
                                break;
                            }
                            case 23 /* SWFActionTags.POP */: {
                                actionStack.pop();
                                break;
                            }
                            case 76 /* SWFActionTags.DUPLICATE */: {
                                actionStack.push(actionStack[actionStack.length - 1]);
                                break;
                            }
                            case 135 /* SWFActionTags.STORE_REGISTER */: {
                                actionRegisters[reader.readUInt8()] = actionStack[actionStack.length - 1];
                                break;
                            }
                            case 28 /* SWFActionTags.GET_VARIABLE */: {
                                let gvName = actionStack.pop();
                                if (!(gvName in actionVariables))
                                    actionVariables[gvName] = {};
                                actionStack.push(actionVariables[gvName]);
                                break;
                            }
                            case 29 /* SWFActionTags.SET_VARIABLE */: {
                                let svValue = actionStack.pop();
                                actionVariables[actionStack.pop()] = svValue;
                                break;
                            }
                            case 66 /* SWFActionTags.INIT_ARRAY */: {
                                let arraySize = actionStack.pop();
                                let array = [];
                                for (let i = 0; i < arraySize; i++)
                                    array.push(actionStack.pop());
                                actionStack.push(array);
                                break;
                            }
                            case 78 /* SWFActionTags.GET_MEMBER */: {
                                let gmName = actionStack.pop();
                                let gmObject = actionStack.pop();
                                if (!(gmName in gmObject))
                                    gmObject[gmName] = {};
                                actionStack.push(gmObject[gmName]);
                                break;
                            }
                            case 79 /* SWFActionTags.SET_MEMBER */: {
                                let smValue = actionStack.pop();
                                let smName = actionStack.pop();
                                actionStack.pop()[smName] = smValue;
                                break;
                            }
                            default:
                                //console.log("FOUND UNSUPPORTED ACTION TAG: " + action.action.toString(16));
                                break;
                        }
                    }
                    if (actionVariables["_root"] !== undefined)
                        tag.doInclude = true;
                    tag.pool = constantPool;
                    tag.variables = actionVariables;
                    break;
                }
                default:
                    //tag.data = buff.buffer_raw.slice(buff.pointer, buff.pointer + tagHeader.length);
                    break;
            }
            if (tag.doInclude) {
                delete tag.doInclude;
                tags.push(tag);
            }
            reader.seek(tagHeader.position + tagHeader.length);
        }
        return tags;
    }
}
